import { HttpService } from '@Services/index';
import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/useBoundStore';

interface ValidateMfaRequest {
  answer: string;
}

interface ValidateMfaResponse {
  accessToken: string;
  allowEditingPersonalDetails: boolean;
}

export const validateAuthorizedUserMfa = async (
  data: ValidateMfaRequest
): Promise<ValidateMfaResponse> => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;

  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/validateMfa`;

  try {
    const response = await HttpService.post<ValidateMfaResponse>(url, {
      answer: data.answer,
      mfaType: 'SMS',
    });
    return response.data as ValidateMfaResponse;
  } catch (error) {
    throw error;
  }
};

export const useValidateAuthorizedUserMfa = () =>
  useMutation({
    mutationFn: validateAuthorizedUserMfa,
  });

export const SendMfaCode = async () => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;

  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/sendOtp`;

  try {
    await HttpService.post(url, {
      mfaType: 'SMS',
    });
  } catch (error) {
    throw error;
  }
};

export const useSendMfaCode = () =>
  useMutation({
    mutationFn: SendMfaCode,
  });
